import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from '../dialogs/dialogs.module';
import { PersonalizationDialogComponent } from './personalization-dialog-component';
import { CkEditorPersonalizationPluginService } from './ck-editor-personalization-plugin.service';
import { PersonalizationComponentApi } from './personalization.api';
import { CommonDirectivesModule } from '../directives/common-directives.module';
import { CommonComponentsModule } from '../components/common-components.module';

@NgModule({
  imports: [CommonModule, FormsModule, DialogModule, TranslateModule.forChild(), CommonDirectivesModule, CommonComponentsModule],
  declarations: [PersonalizationDialogComponent],
  entryComponents: [PersonalizationDialogComponent],
  providers: [
    CkEditorPersonalizationPluginService, PersonalizationComponentApi
  ]
})
export class CkEditorPersonalizationPluginModule {
}
